// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__1a36E","productName":"Table_productName__G-u0H"};